import { Components } from "./utils/components";
Components.init();
import "./components/forms/vacancy-application-form";
import "./components/forms/enquiry-form";
import "./components/forms/umbraco-enquiry-form";
import "./components/forms/list-form";
Components.setup();
/* LEGACY CODE FROM WORDPRESS  */
//	import './modernizr';

import './fonts';
import './packages';
import './theme'; //import './theme-jquery';

import './home-jquery'; //import './cookies';

/* NEW COMPONENTS  */